@if (visible | async) {
<div class="top-notice-bar d-flex justify-content-between align-items-center position-fixed">
    <div class="top-notice-bar__content flex-grow-1 d-flex justify-content-center align-items-center py-1">
        <p class="top-notice-bar__message mb-0">We have updated our Terms of Use, please review them <a
                [href]="termsOfUseUrl" target="_blank">here</a></p>
    </div>
    <div class="top-notice-bar__actions mx-2 d-flex flex-row-reverse justify-content-end">
        <button type="button" class="btn-link btn-link-primary m-0" title="Dismiss" [disabled]="saving"
            (click)="dismiss()">
            <span class="material-icons align-bottom">
                close
            </span>
        </button>
        <button type="button" class="btn-link btn-link-primary m-0" [disabled]="saving" (click)="dismissPermanently()">
            Don't show again
        </button>
    </div>
</div>
}